export const HINT_INFO = (position?: string) => ({
  ORDER_LIST: {
    title: 'Реестр заказов и поставок',
    description:
      position !== 'BUYER'
        ? 'Здесь заказчик согласовывает и погашает финансовые требования от поставщика. Выберите заказы по которым хотите погасить финансовые требования.'
        : 'Здесь поставщик создает финансовые требования по реализуемым товарам. Выберите реализации по которым хотите получить финансирование.',
  },
  SPECIFICATION_LIST: {
    title: position === 'BUYER' ? 'Детали заказа' : 'Детали поставки',
    description:
      position === 'BUYER'
        ? 'Заказчик выбирает необходимые реализации, по которым выставлено финансовое требование (ожидает оплаты). После успешного подписания и оплаты произойдёт зачисление гибридного актива.'
        : 'Поставщик формирует финансовое требование, выбирая реализации на необходимую сумму. Отмечайте галочками необходимые реализации, после нажмите “Создать финансовое требование”',
  },
  FINANCIAL_ISSUE: {
    title: '',
    description:
      'Для выпуска финансового требования необходимо ознакомиться с деталямии операции и подписать документы с помощью УКЭП. После того, как требование будет согласовано с Оператором, произойдёт выпуск актива.',
  },
  ISSUE_HYBRID: {
    title:
      position === 'BUYER'
        ? 'Оплата финансового требования'
        : 'Выставление финансового требования',
    description:
      position !== 'BUYER'
        ? 'Для выставления финансового требования необходимо ознакомиться с деталямии операции и подписать документы с помощью УКЭП. После этого требование направляется заказчику.'
        : 'Для оплаты финансового требования необходимо ознакомиться с деталямии операции и подписать документы с помощью УКЭП. После этого происходит выпуск.',
  },
  PURCHASE: { title: '', description: '' },
  CREDIT_ASSET_DETAILS: { title: 'Заем', description: '' },
  FINANCIAL_ASSET_DETAILS: { title: 'Финансовый токен', description: '' },
  SALE: { title: '', description: '' },
  CREDIT: { title: '', description: '' },
  HISTORY: { title: '', description: '' },
  HYBRID_ASSET_DETAILS: { title: 'Гибридный токен', description: '' },
});
